/* eslint-disable */

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "IChat": [
      "Chat",
      "PrivateChat"
    ],
    "IFile": [
      "AttachedFile",
      "ChatImage",
      "MessageFile",
      "UserImage"
    ],
    "IMessage": [
      "FileMessage",
      "ForwardMessage",
      "NotificationMessage",
      "RegularMessage"
    ],
    "INotificationText": [
      "NotificationText",
      "NotificationTodo",
      "NotificationUser"
    ],
    "IUser": [
      "ActiveUser",
      "InvitedUser"
    ],
    "FlowItem": [
      "Chat",
      "PrivateChat",
      "Reminder"
    ],
    "ForwardedMessage": [
      "DeletedMessage",
      "FileMessage",
      "RegularMessage"
    ],
    "MyUser": [
      "ActiveUser",
      "RegisteringUser"
    ],
    "NotificationDSL": [
      "NotificationText",
      "NotificationTodo",
      "NotificationUser"
    ],
    "QuotedMessage": [
      "DeletedMessage",
      "FileMessage",
      "ForwardMessage",
      "RegularMessage"
    ],
    "RegisteredUser": [
      "ActiveUser"
    ],
    "User": [
      "ActiveUser",
      "InvitedUser"
    ]
  }
};
      export default result;
    